import { Typography } from "@mui/material";
import React from "react";

const WelcomeMessage = (): React.JSX.Element => (
  <React.Fragment>
    <Typography
      variant="h4"
      color="initial"
      sx={{
        mb: 1,
        fontWeight: "bold",
        color: (theme) => theme.palette.primary.main,
        textAlign: { xs: "center", sm: "left" },
      }}
    >
      Deine Meinung zählt!
    </Typography>

    <Typography
      variant="body1"
      color="initial"
      sx={{ mb: 1, textAlign: { xs: "center", sm: "left" } }}
    >
      Wir möchten unser Angebot kontinuierlich weiterentwickeln – und dabei ist
      uns dein Feedback besonders wichtig. Bitte nimm dir einen Moment Zeit, um
      deine Erfahrungen mit dem Coaching zu teilen.
    </Typography>

    <Typography
      variant="body1"
      color="initial"
      sx={{ mb: 1, textAlign: { xs: "center", sm: "left" } }}
    >
      Unten findest du einige Aussagen, die du ganz einfach per Klick bewerten
      kannst (Sterne oder Themenauswahl).
    </Typography>

    <Typography
      variant="body1"
      color="initial"
      sx={{ textAlign: { xs: "center", sm: "left" } }}
    >
      Gerne kannst du im Freitextfeld deine individuelle Rückmeldung an deinen
      Coach geben.
    </Typography>
  </React.Fragment>
);

export default WelcomeMessage;
